import { render } from "./BeaconPurposes.vue?vue&type=template&id=19067d6a"
import script from "./BeaconPurposes.vue?vue&type=script&lang=js"
export * from "./BeaconPurposes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__